import PageLayoutMain from "./components/PageLayoutMain";

const Benutzer = () => {
  return (
    <PageLayoutMain />
  );
};

export default Benutzer;
